// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.
import {
  CdkConnectedOverlay,
  Overlay,
  OverlayModule,
} from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { Component, CUSTOM_ELEMENTS_SCHEMA, ViewChild } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { CtsGantryFilterLogService } from '../services/cts-gantry-filter-log.service';
import { debounceTime, Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'app-cts-gantry-filter-dropdown',
  standalone: true,
  imports: [CommonModule, OverlayModule, TranslateModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './cts-gantry-filter-dropdown.component.html',
  styleUrl: './cts-gantry-filter-dropdown.component.scss',
})
export class CtsGantryFilterDropdownComponent {
  @ViewChild(CdkConnectedOverlay) cdkConnectedOverlay:
    | CdkConnectedOverlay
    | undefined;

  private readonly KEY_ESCAPE = 'Escape';
  private readonly overlayOpenSubject = new Subject<boolean>();

  private readonly unsubscribe = new Subject<void>();

  protected isfilterDropdownHeaderOpen = false;
  protected scrollStrategy = this.overlay.scrollStrategies.close();

  public constructor(
    protected readonly filterLogService: CtsGantryFilterLogService,
    private readonly translateService: TranslateService,
    private readonly overlay: Overlay,
  ) {
    this.listenToOverlayOpen();
  }

  private listenToOverlayOpen(): void {
    this.overlayOpenSubject
      .pipe(debounceTime(50), takeUntil(this.unsubscribe))
      .subscribe(this.overlayOpenSubscribeFn);
  }

  private readonly overlayOpenSubscribeFn = (isOpen: boolean) =>
    (this.isfilterDropdownHeaderOpen = isOpen);

  protected overlayOpenNext(isOpen: boolean): void {
    this.overlayOpenSubject.next(isOpen);
  }

  protected onOverlayKeydown(keyboardEvent: KeyboardEvent): void {
    if (this.KEY_ESCAPE === keyboardEvent.key) {
      this.overlayOpenNext(false);
    }
  }

  public labelDropdown(): string {
    const labels: string[] = [];
    if (this.filterLogService.filter.errors) {
      labels.push(this.translateService.instant('cts.gantry.errors'));
    }
    if (this.filterLogService.filter.informations) {
      labels.push(this.translateService.instant('cts.gantry.informations'));
    }
    if (this.filterLogService.filter.warnings) {
      labels.push(this.translateService.instant('cts.gantry.warnings'));
    }
    return labels.length === 0 || labels.length === 3
      ? this.translateService.instant('cts.gantry.allLogs')
      : labels.join(', ');
  }
}
